<template>
  <div>
    <div v-if="!ready">
      <v-container class="readingcontainer">
        <v-row class="fill-height mt-5" align-content="center" justify="center">
          <v-col class="subtitle-1 text-center mt-5" cols="12">
            <img class="logo mt-5" alt="Logo Realtec" src="@/assets/img/logorealtec.svg" />
          </v-col>
          <v-col cols="6" class="text-center">
            <div style="display: flex; justify-content: center;">
              <v-progress-linear
                style="    width: 150px;"
                color="#fff"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-else id="wrapper" class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
      <side-bar style="overflow: auto">
        <div class="boxmsguser">
          <h3 class="tittle" style="margin-top:8px">Olá, {{user_name}}</h3>
          <p class="category">Bem vindo novamente</p>
        </div>

        <sidebar-link disabled to="/dashboard" @click.native="toggleSidebar">
          <md-icon>dashboard</md-icon>
          <p>Dashboard</p>
        </sidebar-link>
        <sidebar-link to="/acessosRealtec" @click.native="toggleSidebar">
          <md-icon>lock_person</md-icon>
          <p>Acessos Realtec</p>
          <!--<md-icon>
            <font-awesome-icon small icon="user-lock" />
          </md-icon>
          <p style="text-transform: none">Acessos Realtec</p>

          <!- -<div v-if="countNewAcessoRealtec > 0" class="app-layout-dashboard-badge red darken-1 animated heartBeat">
            <span class="caption font-weight-bold white- -text">{{countNewAcessoRealtec}}</span>
          </div>-->
        </sidebar-link>
        <sidebar-link to="/clientes" @click.native="toggleSidebar">
          <md-icon>people</md-icon>
          <p>Clientes</p>
        </sidebar-link>
        <sidebar-link v-if="privcodigo == 14 || privcodigo == 16 || usucodigo == 8" to="/boletos" @click.native="toggleSidebar">
          <md-icon>money</md-icon>
          <p>Boletos</p>
        </sidebar-link>        
        <sidebar-link to="/arquivos" @click.native="toggleSidebar">
          <md-icon>archive</md-icon>
          <p>Arquivos</p>
        </sidebar-link>
        <sidebar-link to="/versoes" @click.native="toggleSidebar">
          <md-icon>verified</md-icon>
          <p>Versões</p>
          <!--<md-icon style="color: #ffcc00 !important; position: absolute; right: 2px">new_releases</md-icon>-->
        </sidebar-link>        
        <sidebar-link to="/logs" @click.native="toggleSidebar">
          <md-icon>
            <font-awesome-icon icon="clipboard-list" />
          </md-icon>
          <p>Logs</p>
        </sidebar-link>
        <!--<sidebar-link to="/vendaRapidaNFCe" @click.native="toggleSidebar">
          <md-icon>
            <font-awesome-icon icon="file-invoice" />
          </md-icon>
          <p style="text-transform: none">NFC-e's</p>
        </sidebar-link> -->
        <sidebar-link to="/comandosValidacaoLog" @click.native="toggleSidebar">
          <md-icon>checklist</md-icon>
          <p style="text-transform: none">Comandos de validação</p>
        </sidebar-link> 
        <sidebar-link to="/notificacoes" @click.native="toggleSidebar">
          <md-icon>notifications</md-icon>
          <p>Notificações</p>
        </sidebar-link>
        <!--<sidebar-link to="/estatisticasAcesso" @click.native="toggleSidebar">
          <md-icon>query_stats</md-icon>
          <p style="text-transform: none">Estatísticas de Acesso</p>
        </sidebar-link>         -->
        <sidebar-link to="/login">
          <md-icon>exit_to_app</md-icon>
          <p>Sair</p>
        </sidebar-link>
        <v-progress-circular
          v-show="isLoading"
          style="position: absolute;
    bottom: 10vh;
    left: 2vw;"
          indeterminate
          color="#fff"
        ></v-progress-circular>
      </side-bar>

      <div
        @click="()=>{
          if(isMobile && this.$sidebar.showSidebar)
            this.$sidebar.displaySidebar(false);
        }"
        id="main-panel"
        class="main-panel"
        v-resize="onResize"
      >
        <top-navbar
          class="navbar"
          :class="{ 'navbar--hidden': !showNavbar }"
          v-if="isMobile"
          style="z-index: 20"
        ></top-navbar>

        <dashboard-content :style="!isMobile ? 'margin-top: 0px;' : 'margin-top: 100px;'"></dashboard-content>

        <content-footer class="footerMain" v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<style scoped  lang="scss"></style>
<script>
import * as Auth from "../providers/auth.service";
import TopNavbar from "./TopNavbar.vue";
var jwt = require("jsonwebtoken");
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import * as ClientesService from "../providers/clientes.service";

import { api } from "@/services/index";
import {
  getAcessoRealtecClientes,
  getAcessoRealtec
} from "@/services/modules/acessoRealtec.js";
import store from "@/store/index.js";

export default {
  sockets: {
    connect() {
      console.log("socket connected");
    }
  },
  data() {
    return {
      showNavbar: true,
      lastScrollPosition: 0,
      isLoading: false,
      user: null,
      user_name: "",
      ready: false,
      isMobile: false,
      privcodigo: 0,
      usucodigo: 0,
    };
  },
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter
  },
  created() {
    var self = this;
    Auth.refreshToken()
      .then(r => {
        var fUser = jwt.decode(localStorage.getItem("token"));
        this.privcodigo = fUser.PRIVCODIGO;
        this.usucodigo = fUser.USUCODIGO;
        self.user_name = fUser.USUNOME;
        self.ready = true;
        var hotSecurity = setInterval(() => {
          if (self.$route.name == "Login") {
            clearInterval(hotSecurity);
          }
          Auth.refreshToken()
            .then(r => {
              //console.log(r.message);
            })
            .catch(() => {
              clearInterval(hotSecurity);
              self.$router.push({ name: "Login" });
            });
        }, 200000);

        //acessos-realtec
        getAcessoRealtecClientes();
        getAcessoRealtec({
          acRealSituacao: 1,
          usuCodigo: store.state.user.data.USUCODIGO
        });
      })
      .catch(() => {
        self.$router.push({ name: "Login" });
      });
  },
  mounted() {
    var self = this;
    window.addEventListener("scroll", self.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      // Get the current scroll position
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return;
      }
      // Here we determine whether we need to show or hide the navbar
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition;
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },

    toggleSidebarr() {
      this.$sidebar.displaySidebar(false);
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    }
  },
  computed: {
    user() {
      return store.state.user.data;
    },
    countNewAcessoRealtec() {
      const acessosRealtec = store.state.acessoRealtec.data;
      let count = 0;

      acessosRealtec.forEach(_acessoRealtec => {
        if (_acessoRealtec.new) count++;
      });
      return count;
    }
  },
  props: {}
};
</script>
<style scoped>
.navbar {
  height: 80px;
  width: 100vw;
  position: fixed;
  box-shadow: 0 2px 15px rgba(71, 120, 120, 0.5);
  transform: translate3d(0, 0, 0);
  transition: 0.1s all ease-out;
}
.navbar.navbar--hidden {
  box-shadow: none;
  transform: translate3d(0, -100%, 0);
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
}
.logo {
  width: 250px;
  background: transparent !important;
  animation: bounce 2s infinite;
}
.boxmsguser {
  padding: 17px;
  margin: 15px;
  border-radius: 4px;
  color: rgb(255, 255, 255);
  background: #2a5377;
  cursor: default;
}
.readingcontainer {
  height: 100vh;
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: row;
  background: #333333;
  align-items: center;
  justify-content: center;
}

.main-panel {
  min-height: 100vh;
  background-color: #333333;
}
</style>
<style scoped >
body {
  background: #333333 !important;
}

.app-layout-dashboard-badge {
  position: absolute;
  top: 5px;
  right: 10px;
  width: 23px;
  height: 23px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  border-radius: 15px;
}

.sidebar-wrapper{
  height: 100px !important;
}

</style>